export default __webpack_public_path__ + "static/media/granville14.cea9c7e1.jpg";